import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import {computed,ref} from 'vue'
import {Image as AntImage} from 'ant-design-vue'
import AdminImagePreview from './AdminImagePreview.vue'
import {previewImageUrl} from '@/utils/adminImage'
const __default__ = {inheritAttrs:false}
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AdminImage',
  props: {
    src: { default: '' },
    width: {},
    height: {},
    preview: { type: [Boolean, Object], default: true }
  },
  setup(__props: any) {

const props=__props
const opened=ref(false)
const fullSource=computed(()=>typeof props.preview==='object' && props.preview.src?props.preview.src:previewImageUrl(props.src))
function dimension(value?:string|number){return typeof value==='number'?value+'px':value}
function open(){if(props.preview!==false && props.src)opened.value=true}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "admin-image",
    style: _normalizeStyle({width:dimension(_ctx.width),height:dimension(_ctx.height)})
  }, [
    _createVNode(_unref(AntImage), _mergeProps(_ctx.$attrs, {
      src: _ctx.src,
      width: _ctx.width,
      height: _ctx.height,
      preview: false,
      onClick: open
    }), null, 16, ["src", "width", "height"]),
    (opened.value)
      ? (_openBlock(), _createBlock(AdminImagePreview, {
          key: 0,
          visible: opened.value,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((opened).value = $event)),
          src: fullSource.value,
          title: String(_ctx.$attrs.alt || '')
        }, null, 8, ["visible", "src", "title"]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})